module.exports = __webpack_public_path__ + "img/voyage.a2d0f170.svg";